export default "__VITE_ASSET__BBDl2qox__"